import React, { FC, useState, useEffect, useContext, useCallback } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';

import OrderDetails from 'featureLib/OrderDetails';
import {
  ACCOUNT_ADDRESS_CONFIG_AOI,
  CONTACT_DETAILS_FORM_CONFIG,
  DEFAULT_FORM_CONFIG_AOI,
  PAN_GST_FORM_CONFIG_AOI,
  productOptionsAOI,
  typeOfOrderOptionsAOI
} from 'featureLib/OrderDetails/formConfig';
import { RADIO_OPTIONS as siteTypeOptions, SINGLE_SITE, ERROR_TOAST, PAN_GST_RADIO_OPTIONS } from 'home/view/manage-feasibility/constants';
import { IFORM, IFORM_ELEMENT } from 'featureLib/FormBuilder';
import { getDefaultValue, getFormValue, getSiteOptionsAndValue, convertLeadToOrderDetailsFormData, convertLsiToOrderDetailsFormData } from './form.control';
import { createNewLeadHandler, createNewLeadHandlerAOI, fetchAOIAccounts } from 'tokenGeneration/response.handler';
import { prepareCreateLeadPayload } from './request.mapper';
import { AppContext } from 'App';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { handleError, findParamFromUrl, isSingleUpgradeOrShiftingJourney, setInSessionStorage, getFromSessionStorage, getAddress } from 'common/utils/app.utils';
import {
  PRODUCT_ALIAS_MAP,
  CUSTOMER_SEGMENT,
  TYPEOF_ORDER,
  getProductType,
  LSI_ERRORS,
  STORAGE_KEY,
  JOURNEY_TYPE,
  isShiftingJourney,
  GENERIC_ERROR_MESSAGE
} from 'common/constants/app.constants';
import { getLsiDetails } from 'home/view/upgrade-order/services';
import CircuitDetails from './CircuitDetails';
import MainLoader from 'common/components/loader/loader.component';
import { MODULE_ID } from 'home/common/constants/constants';
import { SESSION_STORAGE } from 'home/view/upgrade-order/constants';
import LoiPopup from './LoiPopup';
import PanGstAccordion from './PanGstAccordion';
import { addressValidator, gstinValidator, panValidator, pincodeValidator } from 'common/utils/validator';
import AccountAddressAccordion from './AccountAddressAccordion';
import { fetchCityStateList } from 'common/services/http.service';

interface Props {
  onFormLoad: (formData: any) => void;
  onLeadSuccessCb: (formData: any) => void;
}

export const OrderDetailsAccordion: FC<Props> = ({ onFormLoad, onLeadSuccessCb }) => {
  const [pangstFormState, setpangstFormState] = useState<any>(() => PAN_GST_FORM_CONFIG_AOI);
  const [orderFormState, setOrderFormState] = useState<any>(() => DEFAULT_FORM_CONFIG_AOI);
  const [contactFormState, setContactFormState] = useState<any>(() => CONTACT_DETAILS_FORM_CONFIG);
  const [accountFormState, setAccountFormState] = useState<any>(() => ACCOUNT_ADDRESS_CONFIG_AOI);
  const [loader, setLoader] = useState<boolean>(false);
  const [lsiLoading, setLsiLoading] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [lsiData, setLsiData] = useState<any>(null);
  const [lsiError, setLsiError] = useState<string>('');
  const [renderCircuitAccordion, setRenderCircuitAccordion] = useState<boolean>(false);
  const [showEditBtn, setShowEditBtn] = useState<boolean>(false);
  const [showLoiPopup, setShowLoiPopup] = useState<boolean>(false);
  const [showOrderForm, setShowOrderForm] = useState<boolean>(false);
  const [pangstAccordionExpanded, setPanGstAccordionExpanded] = useState<boolean>(true);
  const [addressPara, setAddressPara] = useState<string>('');
  const [showAddress, setShowAddress] = useState<boolean>(false);
  // const [pangstError, setPanGstError] = useState('');

  const { selectedRadio, setToast, setSelectedRadio } = useContext<any>(AppContext);

  const isAOI = true;
  // let state = '';
  // let country = '';
  const [stateCountryPayload, setStateCountryPayload] = useState({ state: '', country: '' });
  const getOptionsForTypeOfOrder = (currentProduct: { displayName: string; key: string }) => {
    const options = typeOfOrderOptionsAOI.filter((orderType) => orderType.products.includes(currentProduct.key));
    return options;
  };

  const getFormData = (defaultData?: any) => {
    if (defaultData && (isSingleUpgradeOrShiftingJourney() || isShiftingJourney() || isFormSelectedForSingleUpgradeOrShifting())) {
      return defaultData && convertLsiToOrderDetailsFormData(defaultData);
    }

    return convertLeadToOrderDetailsFormData(getCurrentLead() ?? {});
  };

  const getFormForOrder = (disableAll: boolean, defaultData?: any) => {
    const savedOrderValue = getFormData(defaultData)?.orderForm ?? {};
    const defaultValue = {
      selectedRadio
    };

    const defaultOrderFormState = getDefaultValue(DEFAULT_FORM_CONFIG_AOI, { ...defaultValue, ...savedOrderValue }, disableAll);

    const updatedTypeOfOrder = {
      ...defaultOrderFormState['typeOfOrder'],
      element: { ...defaultOrderFormState['typeOfOrder']?.element, props: { options: savedOrderValue?.orderTypeOptions } }
    };
    const updatedSiteType = {
      ...defaultOrderFormState['siteType'],
      element: { ...defaultOrderFormState['siteType']?.element, props: { options: savedOrderValue?.siteListOptions } }
    };
    const updatedLoiAvailable = {
      ...defaultOrderFormState?.loiAvailable,
      hide: defaultOrderFormState?.typeOfOrder?.value?.key !== TYPEOF_ORDER.NEW_PRE_ORDER && defaultOrderFormState?.typeOfOrder?.value?.key !== TYPEOF_ORDER.UPGRADE_PRE_ORDER
    };

    return { ...defaultOrderFormState, typeOfOrder: updatedTypeOfOrder, siteType: updatedSiteType, loiAvailable: updatedLoiAvailable };
  };

  const getFormForContact = (disableAll: boolean, defaultData?: any) => {
    const savedContactForm = getFormData(defaultData)?.contactForm ?? {};
    const defaultContactForm = getDefaultValue(CONTACT_DETAILS_FORM_CONFIG, savedContactForm ?? {}, disableAll);

    return defaultContactForm;
  };

  const getFormState = (disableAll: boolean, defaultData?: any) => {
    const orderForm = getFormForOrder(disableAll, defaultData);
    const contactForm = getFormForContact(disableAll, defaultData);

    return { orderForm, contactForm };
  };

  const updatePanGstFormState = (): void => {
    const currentLeadData = getCurrentLead?.();

    const {
      customer: { panNumber, gstNumber } = {
        panNumber: '',
        gstNumber: ''
      }
    } = currentLeadData || {
      customer: {
        panNumber: '',
        gstNumber: ''
      }
    };

    const getSelectedSearchType = () => {
      if (panNumber) {
        return PAN_GST_RADIO_OPTIONS.find((item: any) => item.id === 'pan');
      }

      if (gstNumber) {
        return PAN_GST_RADIO_OPTIONS.find((item: any) => item.id === 'gst');
      }

      return PAN_GST_RADIO_OPTIONS.find((item: any) => item.id === 'gst');
    };

    setpangstFormState((pangstFormState: IFORM) => ({
      ...pangstFormState,
      searchType: {
        ...pangstFormState.searchType,
        value: getSelectedSearchType(),
        disabled: currentLeadData ? true : false
      },
      searchValue: {
        ...pangstFormState.searchValue,
        value: panNumber || gstNumber || '',
        disabled: currentLeadData ? true : false
      }
    }));

    if (currentLeadData) {
      setPanGstAccordionExpanded(false);
      setShowOrderForm(true);
    }
  };

  const setOrderForm = (disableAll: boolean) => {
    const orderFormCopy = Object.assign({}, orderFormState);
    Object.entries(orderFormCopy).forEach(([_key, value]) => {
      (value as any)['disabled'] = disableAll;
    });
    setOrderFormState(orderFormCopy);
  };

  const isFormSelectedForSingleUpgradeOrShifting = () => {
    const orderType = orderFormState?.typeOfOrder?.value?.key === TYPEOF_ORDER.UPGRADE || orderFormState?.typeOfOrder?.value?.key === TYPEOF_ORDER.SHIFTING;
    const siteType = orderFormState?.siteType?.value?.id === SINGLE_SITE;
    const isSingleUpgradeSelected = siteType && orderType;

    return isSingleUpgradeSelected;
  };

  const handleCreateLead = () => {
    const formValue = { ...orderFormState, ...contactFormState, ...pangstFormState };
    setLoader(true);
    let payload = prepareCreateLeadPayload(formValue);
    if (payload && !payload.state) {
      payload.state = stateCountryPayload && stateCountryPayload.state;
    }
    if (payload && !payload.country) {
      payload.country = stateCountryPayload && stateCountryPayload.country;
    }
    const params = { serviceType: payload.productName };
    createNewLeadHandlerAOI({ payload, params }).then(
      (resp) => {
        // const { orderForm, contactForm } = getFormState(true);
        setLoader(false);
        // setOrderFormState(orderForm);
        // setContactFormState(contactForm);
        setpangstFormState((pangstFormState: any) => ({
          ...pangstFormState,
          searchType: {
            ...pangstFormState.searchType,
            disabled: true
          },
          searchValue: {
            ...pangstFormState.searchValue,
            disabled: true
          }
        }));

        onLeadSuccessCb(getFormValue(formValue));
      },
      (error) => {
        setLoader(false);
        handleError(error);
      }
    );
  };

  const getAPIErrorMessage = (address: any) => (address?.line1 || address?.line2 ? '' : 'Invalid address');

  const handleFetchAOIAccounts = (updatedForm = {}) => {
    const formValue = Object.keys(updatedForm).length > 0 ? { ...updatedForm } : { ...pangstFormState };
    setLoader(true);
    const selectedType = formValue.searchType.value?.id;
    const inputValue = formValue.searchValue.value;
    const params = { [`${selectedType}`]: inputValue };
    setpangstFormState((pangstFormState: IFORM) => ({
      ...pangstFormState,
      searchValue: {
        ...pangstFormState.searchValue,
        loader: true
      }
    }));

    fetchAOIAccounts(params).then(
      (resp: any) => {
        if (!resp) {
          setpangstFormState((pangstFormState: IFORM) => ({
            ...pangstFormState,
            searchValue: {
              ...pangstFormState.searchValue,
              loader: false,
              errors: ['Customer Details are empty for the specified PAN / GST' || GENERIC_ERROR_MESSAGE]
            }
          }));
        } else {
          const accountOptions: any = [];
          const response = resp?.data?.result;
          setStateCountryPayload({
            ...stateCountryPayload,
            state: response[0]?.address?.state,
            country: response[0]?.address?.country
          });
          // state = response[0]?.address?.state
          // country = response[0]?.address?.country;

          response.forEach((data: any) => {
            let accountItem = { key: data?.name, displayName: `${data?.name} - ${data?.rootAccountNumber}`, rootAccountNumber: data?.rootAccountNumber, address: data?.address };
            accountOptions.push(accountItem);
          });

          setpangstFormState((pangstFormState: IFORM) => {
            // const test = pangstFormState.searchValue?.className.split()
            return {
              ...pangstFormState,
              searchValue: {
                ...pangstFormState.searchValue,
                errors: getAPIErrorMessage(accountOptions[0].address) ? [] : [],
                loader: false
              },
              accountName: {
                ...pangstFormState.accountName,
                value: accountOptions[0] || {},
                hide: false,
                disabled: accountOptions.length === 1,
                element: {
                  ...pangstFormState.accountName.element,
                  props: {
                    ...pangstFormState.accountName.element.props,
                    options: accountOptions
                  }
                }
              },
              address: {
                ...pangstFormState.address,
                value: getAddress(accountOptions[0].address),
                disabled: true
                // errors: getAPIErrorMessage(accountOptions[0].address) ? [getAPIErrorMessage(accountOptions[0].address)]: []
              },
              ...(getAPIErrorMessage(accountOptions[0].address)
                ? {
                    addressLine: {
                      ...pangstFormState.addressLine,
                      hide: false
                    },
                    pincode: {
                      ...pangstFormState.pincode,
                      hide: false
                    },
                    city: {
                      ...pangstFormState.city,
                      hide: false
                    }
                  }
                : {
                    addressLine: {
                      ...pangstFormState.addressLine,
                      hide: true
                    },
                    pincode: {
                      ...pangstFormState.pincode,
                      hide: true
                    },
                    city: {
                      ...pangstFormState.city,
                      hide: true
                    }
                  })
            };
          });

          setAddressPara(getAddress(accountOptions[0].address));
          if (getAPIErrorMessage(accountOptions[0].address)) {
            setShowAddress(false);
          } else {
            setShowAddress(true);
          }

          // setAccountFormState((accountFormState: any) => ({
          //   ...accountFormState,
          //   accountName: {
          //     ...accountFormState.accountName,
          //     value: accountOptions[0] || {},
          //     hide: false,
          //     disabled: accountSelectorDisabled,
          //     element: {
          //       ...accountFormState.accountName.element,
          //       props: {
          //         ...accountFormState.accountName.element.props,
          //         options: accountOptions
          //       }
          //     }
          //   },
          //   address: {
          //     ...accountFormState.address,
          //     value: getAddress(accountOptions[0].address),
          //     hide: false,
          //     disabled: true
          //   }
          // }));

          // setOrderFormState((orderFormState: any) => ({
          //   ...orderFormState,
          //   accountName: {
          //     ...orderFormState.accountName,
          //     value: accountOptions[0] || {},
          //     element: {
          //       ...orderFormState.accountName.element,
          //       props: {
          //         ...orderFormState.accountName.element.props,
          //         options: accountOptions
          //       }
          //     }
          //   },
          //   address: {
          //     ...orderFormState.address,
          //     value: getAddress(accountOptions[0].address),
          //     disabled: true
          //   }
          // }));
          // const { orderForm, contactForm } = getFormState(true);
          // setPanGstAccordionExpanded(false);
          setLoader(false);

          if (getAPIErrorMessage(accountOptions[0].address)) {
            setShowOrderForm(false);
          } else {
            setShowOrderForm(true);
          }
          // setOrderFormState(orderForm);
          // setContactFormState(contactForm);
        }
      },
      (error) => {
        setLoader(false);
        // handleError(error);
        let errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
        setpangstFormState((pangstFormState: IFORM) => ({
          ...pangstFormState,
          searchValue: {
            ...pangstFormState.searchValue,
            loader: false
          },
          accountName: {
            ...pangstFormState.accountName,
            errors: [errorMsg],
            value: {}
          },
          address: {
            ...pangstFormState.address,
            value: ''
          }
        }));
        setShowOrderForm(false);
      }
    );
  };

  const handleAccountSubmit = () => {};

  // const onSubmit = () => {
  //   setIsEditing(false);

  //   if (isFormSelectedForSingleUpgradeOrShifting()) {
  //     setOrderForm(true);
  //     setContactForm(true);
  //     setShowEditBtn(true);
  //     setRenderCircuitAccordion(true);
  //     setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING);
  //     setSelectedRadio(siteTypeOptions.find((item: { id: string }) => item.id === SINGLE_SITE));
  //     return false;
  //   }

  //   if (isSingleUpgradeOrShiftingJourney() || isShiftingJourney()) {
  //     setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING);
  //     setSelectedRadio(siteTypeOptions.find((item: { id: string }) => item.id === SINGLE_SITE));
  //     setContactForm(true);
  //   } else {
  //     const formValue = { ...orderFormState, ...contactFormState };
  //     const isNewPreOrder = formValue.typeOfOrder.value?.key === TYPEOF_ORDER.NEW_PRE_ORDER;
  //     const isUpgradePreOrder = formValue.typeOfOrder.value?.key === TYPEOF_ORDER.UPGRADE_PRE_ORDER;
  //     const isLoiAvailable = formValue.loiAvailable.value;

  //     if (isNewPreOrder || isUpgradePreOrder) {
  //       if (isLoiAvailable) {
  //         handleCreateLead();
  //       } else {
  //         setShowLoiPopup(true);
  //       }
  //     } else {
  //       handleCreateLead();
  //     }
  //   }
  // };

  const handleLoiPopupProceedClick = () => {
    setShowLoiPopup(false);
    handleCreateLead();
  };

  const setFormConfigForSiteType = (form: IFORM, value: any) => {
    const isSMBCustomer = form?.selectedAccount?.value?.customerSegment === CUSTOMER_SEGMENT.SMB;
    const product = form['productType'].value?.key;
    const selectedSiteType = form?.siteType?.value?.id;
    const { siteListOptions, siteType } = getSiteOptionsAndValue(value, selectedSiteType, product);
    let updatedSiteType = {
      ...form['siteType'],
      value: siteType ?? form['siteType']?.value,
      element: { ...form['siteType']?.element, props: { options: siteListOptions } }
    };

    const updatedLoiAvailable = {
      ...form.loiAvailable,
      hide: value !== TYPEOF_ORDER.NEW_PRE_ORDER && value !== TYPEOF_ORDER.UPGRADE_PRE_ORDER
    };

    const isPreOrderUpgrade = value === 'UPGRADE_PRE_ORDER';
    const updatedProductOptions = isPreOrderUpgrade ? productOptionsAOI.filter((item) => item.key !== 'NLD' && item.key !== 'LL') : productOptionsAOI;
    const updatedProduct = {
      ...form.productType,
      element: {
        ...form.productType.element,
        props: {
          ...form.productType.element.props,
          options: updatedProductOptions
        }
      }
    };

    // filtered site types for SMB
    if (isSMBCustomer) {
      const updatedSiteListOptions = siteListOptions.filter((item: { id: string }) => item.id === SINGLE_SITE);
      updatedSiteType = {
        ...form['siteType'],
        value: updatedSiteListOptions?.[0],
        element: { ...form['siteType']?.element, props: { options: updatedSiteListOptions } }
      };
    }

    setTimeout(() => {
      setOrderFormState({ ...form, siteType: updatedSiteType, loiAvailable: updatedLoiAvailable, productType: updatedProduct });
    }, 300);
  };

  const handleOrderFormChange = ({ field, value, oldValue, newValue, form }: { field: string; value: any; oldValue: any; newValue: any; form: IFORM }) => {
    // const updatedOrderNickName = { ...form['orderNickName'], errors: [], value: getAutoGeneratedOrderNickName({ form }) };
    // if (field === 'selectedAccount' && oldValue?.partyId !== newValue?.partyId) {
    //   const isSMBCustomer = newValue?.customerSegment === CUSTOMER_SEGMENT.SMB;

    //   if (isSMBCustomer) {
    //     // filtered products for SMB
    //     const updatedProductOptions = productOptionsAOI.filter((item: { key: string }) => item.key === 'DSL');
    //     const selectedProduct = updatedProductOptions.find((item: { key: string }) => item.key === getProductType()) ?? updatedProductOptions?.[0];
    //     const updatedProductType = {
    //       ...form['productType'],
    //       value: selectedProduct,
    //       element: {
    //         ...form['productType'].element,
    //         props: { options: updatedProductOptions }
    //       }
    //     };

    //     // filtered type of order for SMB
    //     const updatedTypeOfOrder = {
    //       ...form['typeOfOrder'],
    //       value: typeOfOrderOptionsAOI?.[0],
    //       element: {
    //         ...form['typeOfOrder'].element,
    //         props: { options: typeOfOrderOptionsAOI }
    //       }
    //     };

    //     // filtered site types for SMB
    //     const updatedSiteListOptions = siteTypeOptions.filter((item: { id: string }) => item.id === SINGLE_SITE);
    //     const updatedSiteType = {
    //       ...form['siteType'],
    //       value: updatedSiteListOptions?.[0],
    //       element: { ...form['siteType']?.element, props: { options: updatedSiteListOptions } }
    //     };

    //     setOrderFormState({ ...form, orderNickName: updatedOrderNickName, productType: updatedProductType, typeOfOrder: updatedTypeOfOrder, siteType: updatedSiteType });
    //   } else {
    //     setOrderFormState({ ...form, orderNickName: updatedOrderNickName });
    //   }
    // } else
    if (field === 'accountName' && oldValue?.key !== newValue?.key) {
      setOrderFormState({
        ...form,
        address: {
          ...form.address,
          value: getAddress(newValue.address),
          disabled: true
        }
      });
    } else if (field === 'productType' && oldValue?.key !== newValue?.key) {
      let options = getOptionsForTypeOfOrder(value);
      const isSMBCustomer = form?.selectedAccount?.value?.customerSegment === CUSTOMER_SEGMENT.SMB;

      if (isSMBCustomer) {
        options = options.filter((item: { key: string }) => item.key === TYPEOF_ORDER.NEW);
      }
      const orderTypeValue = options[0];
      const updatedTypeOfOrder = { ...form['typeOfOrder'], value: orderTypeValue, element: { ...form['typeOfOrder']?.element, props: { options } } };
      setTimeout(() => {
        setFormConfigForSiteType({ ...form, typeOfOrder: updatedTypeOfOrder }, orderTypeValue?.key);
      }, 300);
    } else if (field === 'typeOfOrder' && oldValue?.key !== newValue?.key) {
      setFormConfigForSiteType({ ...form }, newValue?.key);
    } else if (field === 'olmId' && oldValue !== newValue) {
      const updatedNewValue = newValue?.toUpperCase();
      let updatedFormData = {};
      if (alphaNumericHandler(newValue)) {
        if (newValue.length > 10) {
          updatedFormData = {
            ...form,
            olmId: {
              ...form.olmId,
              value: oldValue.slice(0, 10)
            }
          };
        } else {
          updatedFormData = {
            ...form,
            olmId: {
              ...form.olmId,
              value: updatedNewValue
            }
          };
        }
      } else {
        if (oldValue.length === 1 && newValue === '') {
          updatedFormData = {
            ...form,
            olmId: {
              ...form.olmId,
              value: newValue
            }
          };
        } else {
          updatedFormData = {
            ...form,
            olmId: {
              ...form.olmId,
              value: oldValue
            }
          };
        }
      }

      setOrderFormState(updatedFormData);
    } else if (field === 'initiatorFullName' && oldValue !== newValue) {
      // ;
      let updatedFormData = {};
      if (nameHandler(newValue)) {
        updatedFormData = {
          ...form,
          initiatorFullName: {
            ...form.initiatorFullName,
            value: newValue
          }
        };
      } else {
        if (oldValue.length === 1 && newValue === '') {
          updatedFormData = {
            ...form,
            initiatorFullName: {
              ...form.initiatorFullName,
              value: newValue
            }
          };
        } else {
          updatedFormData = {
            ...form,
            initiatorFullName: {
              ...form.initiatorFullName,
              value: oldValue
            }
          };
        }
      }
      setOrderFormState(updatedFormData);
    }
  };

  const getAutoGeneratedOrderNickName = ({ form }: { form: IFORM }) => {
    const selectedAccount = form['selectedAccount']?.value?.partyName;
    const productType = form['productType']?.value?.key;
    const typeOfOrder = form['typeOfOrder']?.value?.displayName ?? form['typeOfOrder']?.value?.key;

    const selectedAccountName = selectedAccount?.substr(0, 4)?.toUpperCase();
    const productTypeName = PRODUCT_ALIAS_MAP[productType as keyof typeof PRODUCT_ALIAS_MAP];
    const typeOfOrderName = typeOfOrder;

    const autoGeneratedOrderNickName = selectedAccountName.concat(' ', productTypeName).concat(' ', typeOfOrderName);

    return autoGeneratedOrderNickName;
  };

  const onSubmitPanGst = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setpangstFormState(form?.values);
  }, []);

  const onSubmitAccount = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setAccountFormState(form?.values);
  }, []);

  const onSubmitOrder = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setOrderFormState(form?.values);
  }, []);

  const onSubmitContact = useCallback((form: { isValid: boolean; values: IFORM }) => {
    setContactFormState(form?.values);
  }, []);

  const onOrderFieldChange = useCallback(
    (
      field: string,
      value: any,
      initialState: any,
      { setForm, form, disableAll, oldValue, newValue }: { setForm: Function; form: IFORM; disableAll: Function; oldValue: any; newValue: any }
    ) => {
      handleOrderFormChange({ form, field, value, oldValue, newValue });
    },
    []
  );

  const alphaNumericHandler = (value: any) => {
    return /^[a-zA-Z0-9]+$/.test(value);
  };

  const nameHandler = (value: any) => {
    return /^[a-zA-Z0-9 ]+$/.test(value);
  };

  const onPanGstFormFieldChange = useCallback(
    (
      field: string,
      value: any,
      initialState: any,
      { setForm, form, disableAll, oldValue, newValue }: { setForm: Function; form: IFORM; disableAll: Function; oldValue: any; newValue: any }
    ) => {
      if (field === 'searchType' && oldValue.id !== newValue.id) {
        setAddressPara('');
        setShowAddress(false);
        setpangstFormState({
          ...form,
          searchValue: {
            ...form.searchValue,
            validator: newValue.id === 'pan' ? panValidator : gstinValidator,
            value: '',
            errors: []
          },
          accountName: {
            ...form.accountName,
            hide: true
          },
          address: {
            ...form.address,
            hide: true
          },
          addressLine: {
            ...form.addressLine,
            value: '',
            hide: true
          },
          pincode: {
            ...form.pincode,
            value: '',
            hide: true
          },
          city: {
            ...form.city,
            value: {},
            hide: true
          }
        });
        setShowOrderForm(false);
      }

      if (field === 'searchValue' && oldValue !== newValue) {
        // ;
        console.log(/^[a-zA-Z0-9]+$/.test(value));
        // ;
        console.log('1');
        const updatedNewValue = newValue?.toUpperCase();

        setAddressPara('');
        setShowAddress(false);
        const searchType = form.searchType.value.id;
        const getErrors = () => {
          if (searchType === 'gst' && !gstinValidator(updatedNewValue)) {
            return ['Please enter valid GSTIN'];
          }
          if (searchType === 'pan' && !panValidator(updatedNewValue)) {
            return ['Please enter valid PAN'];
          }

          return [];
        };
        let updatedFormData = {};
        if (alphaNumericHandler(newValue)) {
          updatedFormData = {
            ...form,
            searchValue: {
              ...form.searchValue,
              errors: getErrors(),
              value: updatedNewValue
            },
            accountName: {
              ...form.accountName,
              hide: true
            },
            address: {
              ...form.address,
              hide: true
            },
            addressLine: {
              ...form.addressLine,
              value: '',
              hide: true
            },
            pincode: {
              ...form.pincode,
              value: '',
              hide: true
            },
            city: {
              ...form.city,
              value: {},
              hide: true
            }
          };
        } else {
          if (oldValue.length === 1 && newValue === '') {
            updatedFormData = {
              ...form,
              searchValue: {
                ...form.searchValue,
                errors: getErrors(),
                value: newValue
              },
              accountName: {
                ...form.accountName,
                hide: true
              },
              address: {
                ...form.address,
                hide: true
              },
              addressLine: {
                ...form.addressLine,
                value: '',
                hide: true
              },
              pincode: {
                ...form.pincode,
                value: '',
                hide: true
              },
              city: {
                ...form.city,
                value: {},
                hide: true
              }
            };
          } else {
            updatedFormData = {
              ...form,
              searchValue: {
                ...form.searchValue,
                errors: getErrors(),
                value: oldValue
              },
              accountName: {
                ...form.accountName,
                hide: true
              },
              address: {
                ...form.address,
                hide: true
              },
              addressLine: {
                ...form.addressLine,
                hide: true
              },
              pincode: {
                ...form.pincode,
                hide: true
              },
              city: {
                ...form.city,
                value: {},
                hide: true
              }
            };
          }
        }

        setpangstFormState(updatedFormData);

        if (getErrors()?.length === 0) {
          /** use debounce here for input change */
          setTimeout(() => {
            handleFetchAOIAccounts(updatedFormData);
          }, 1000);
        }

        setShowOrderForm(false);
      }

      if (field === 'accountName' && oldValue !== newValue) {
        console.log(form);
        setpangstFormState({
          ...form,
          searchValue: {
            ...form.searchValue,
            errors: getAPIErrorMessage(newValue.address) ? [] : [] // removed error display on empty address
          },
          address: {
            ...form.address,
            value: getAddress(newValue.address),
            disabled: true
            // errors: getAPIErrorMessage(newValue.address) ? [getAPIErrorMessage(newValue.address)]: []
          }
        });

        setAddressPara(getAddress(newValue.address));
        if (getAPIErrorMessage(newValue.address)) {
          setShowAddress(false);
        } else {
          setShowAddress(true);
        }

        if (getAddress(newValue.address)) {
          setShowOrderForm(true);
        } else {
          // setShowOrderForm(false);
        }
      }

      if (field === 'addressLine' && oldValue !== newValue) {
        if (newValue.length < 5) {
          setpangstFormState({
            ...form,
            addressLine: {
              ...form.addressLine,
              errors: ['Minimum 5 characters required in Address']
            }
          });
        } else {
          setpangstFormState({
            ...form,
            addressLine: {
              ...form.addressLine,
              errors: !addressValidator(newValue) ? ['Invalid characters in Address'] : []
            }
          });
        }
      }

      if (field === 'pincode' && oldValue !== newValue) {
        const digitsOnly = (newValue || '').replace(/\D/g, '');
        const trimmed = digitsOnly.slice(0, 6);

        setpangstFormState((prev: any) => ({
          ...form,
          pincode: {
            ...form.pincode,
            value: trimmed,
            errors: trimmed.length > 0 && !pincodeValidator(trimmed) ? ['Invalid Pincode'] : []
          },
          city: {
            ...form.city,
            value: {},
            hide: false,
            disabled: false,
            element: {
              ...form.city.element,
              props: {
                ...form.city.element.props,
                options: []
              }
            }
          }
        }));

        if (trimmed.length !== 6 || !pincodeValidator(trimmed)) {
          return;
        }
        setpangstFormState((prev: any) => ({
          ...prev,
          pincode: { ...prev.pincode, loader: true }
        }));
        fetchCityStateList(trimmed, { productName: 'DSL' }).then(
          (res) => {
            const response = res?.data?.result || [];
            const cityOptions = response.map((data: any) => ({
              key: data?.city,
              displayName: data?.city,
              data
            }));

            setpangstFormState({
              ...form,
              pincode: {
                ...form.pincode,
                value: trimmed,
                loader: false,
                errors: []
              },
              city: {
                ...form.city,
                value: cityOptions?.[0] || {},
                hide: false,
                disabled: cityOptions.length === 1,
                element: {
                  ...form.city.element,
                  props: {
                    ...form.city.element.props,
                    options: cityOptions
                  }
                }
              }
            });
          },
          (error) => {
            setLoader(false);
            let errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
            setpangstFormState((pangstFormState: IFORM) => ({
              ...pangstFormState,
              pincode: {
                ...pangstFormState.pincode,
                errors: [errorMsg],
                loader: false
              },
              city: {
                ...pangstFormState.city,
                value: {}
              }
            }));
          }
        );
      }
    },
    []
  );

  const onAccountFormFieldChange = useCallback(
    (
      field: string,
      value: any,
      initialState: any,
      { setForm, form, disableAll, oldValue, newValue }: { setForm: Function; form: IFORM; disableAll: Function; oldValue: any; newValue: any }
    ) => {},
    []
  );

  useEffect(() => {
    const validateAddress = addressValidator(pangstFormState?.addressLine?.value) && pangstFormState?.addressLine?.value?.length > 5;
    const validatePincode = pincodeValidator(pangstFormState?.pincode?.value);
    const cityValidator = pangstFormState?.city?.value?.displayName ? true : false;
    const validation = showAddress || (validateAddress && validatePincode && cityValidator);
    setShowOrderForm(validation);
  }, [pangstFormState]);

  const onContactFieldChange = useCallback((field: string, value: any, empty: any, { setForm, form, disableAll }: { setForm: Function; form: IFORM; disableAll: Function }) => {},
  []);

  const getDisableBtn = useCallback(() => {
    if (getCurrentLead() && !isShiftingJourney()) {
      return true;
    }

    const disableSubmit = !orderFormState['accountName']?.value?.id && !orderFormState['salesCode']?.value;

    return loader || disableSubmit;
  }, [orderFormState, loader]);

  const getPanGstFormDisableBtn = useCallback(() => {
    if (getCurrentLead()) {
      return true;
    }

    const disableSubmit = !pangstFormState['searchValue']?.value;

    return loader || disableSubmit;
  }, [pangstFormState, loader]);

  const updateOrderFormWithLsi = (lsiData: any) => {
    setLsiData(lsiData);

    // update order details form
    if (isSingleUpgradeOrShiftingJourney() || isShiftingJourney()) {
      const { orderForm, contactForm } = getFormState(true, lsiData);
      setOrderFormState(orderForm);
      setContactFormState(contactForm);
      onFormLoad?.(getFormValue({ ...orderForm, ...contactForm }));
      setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING);
    }
    // else {
    //   onFormLoad?.(siteTypeOptions.find((item:any) => item?.id === SINGLE_SITE));
    // }
  };

  const fetchLsiDetails = async (lsiId?: string) => {
    try {
      setLsiLoading(true);

      const lsi = lsiId ?? findParamFromUrl('lsi', false) ?? getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID);

      const { res, err } = await getLsiDetails(lsi);
      const result = await (res && res.data && res.data.result);

      if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || LSI_ERRORS.DEFAULT_MSG;
        setLsiLoading(false);
        setLsiData({
          lsiId: lsi,
          installationAddress: { line1: null, city: null, state: null, pincode: null }
        });
        // handleError(err);
        setLsiError(errorMsg);
        throw new Error(errorMsg);
      }

      if (result) {
        // fetching new lsi details
        if (lsiId) {
          let errorMsg = '';

          const {
            product: newProductType,
            customer: { partyId: newPartyId }
          } = result;

          const existingPartyName = orderFormState['selectedAccount']?.value?.partyName;
          const existingPartyId = orderFormState['selectedAccount']?.value?.partyId;
          const existingProductType = orderFormState['productType']?.value?.key;

          if (newPartyId !== existingPartyId) {
            errorMsg = LSI_ERRORS.PARTY_MISMATCH + (existingPartyName ? ` ${existingPartyName}` : '');
          }

          if (newProductType !== existingProductType) {
            errorMsg = LSI_ERRORS.PRODUCT_MISMATCH + (existingProductType ? ` ${existingProductType}` : '');
          }

          if (errorMsg) {
            setLsiError(errorMsg);
            setLsiData(result);
            // setToast(true, errorMsg, ERROR_TOAST);
          } else {
            setLsiError('');
            // setToast(false, '', '');
            updateOrderFormWithLsi(result);
          }
        } else {
          setLsiError('');
          // setToast(false, '', '');
          updateOrderFormWithLsi(result);
        }

        setLsiLoading(false);
      }
    } catch (e) {
      console?.error(e);
    }
  };

  const setContactForm = (disableAll: boolean) => {
    const contactFormCopy = Object.assign({}, contactFormState);
    Object.entries(contactFormCopy).forEach(([_key, value]) => {
      (value as any)['disabled'] = disableAll;
    });
    setContactFormState(contactFormCopy);
  };

  const handleEditClick = () => {
    setShowEditBtn(false);
    setIsEditing(true);
    setContactForm(false);
  };

  useEffect(() => {
    if (isSingleUpgradeOrShiftingJourney() || isShiftingJourney()) {
      fetchLsiDetails();
    } else if (isFormSelectedForSingleUpgradeOrShifting()) {
      setOrderForm(true);
      setContactForm(true);
      setShowEditBtn(true);
      setRenderCircuitAccordion(true);
    } else {
      const { orderForm, contactForm } = getFormState(getCurrentLead() ? true : false);
      updatePanGstFormState();
      setOrderFormState(orderForm);
      setContactFormState(contactForm);
      onFormLoad?.(getFormValue({ ...orderForm, ...contactForm }));
    }
  }, [getCurrentLead()?.leadId]);

  if ((isSingleUpgradeOrShiftingJourney() || isShiftingJourney() || isFormSelectedForSingleUpgradeOrShifting()) && loader) {
    return (
      <div className="container">
        <MainLoader />
      </div>
    );
  }

  return (
    <div className="order-details-accordion">
      {showLoiPopup && <LoiPopup setshowPopup={setShowLoiPopup} onProceedClick={handleLoiPopupProceedClick} />}
      <>
        <PanGstAccordion
          formSchema={pangstFormState}
          onFormChange={onPanGstFormFieldChange}
          onFormSubmit={onSubmitPanGst}
          onSubmit={handleFetchAOIAccounts}
          loader={loader}
          disableBtn={getPanGstFormDisableBtn()}
          pangstAccordionExpanded={pangstAccordionExpanded}
          addressPara={addressPara}
          showAddress={showAddress}
        />
        {/* {true && <span className="loading_icon"></span>} */}
        {/* <AccountAddressAccordion
          formSchema={accountFormState}
          onFormChange={onAccountFormFieldChange}
          onFormSubmit={onSubmitAccount}
          onSubmit={handleAccountSubmit}
          loader={loader}
          disableBtn={getPanGstFormDisableBtn()}
          pangstAccordionExpanded={pangstAccordionExpanded}
        ></AccountAddressAccordion> */}
      </>
      {showOrderForm && (
        <OrderDetails
          onSubmit={handleCreateLead}
          orderFormSchema={orderFormState}
          onOrderFieldChange={onOrderFieldChange}
          onSubmitOrder={onSubmitOrder}
          contactFormSchema={contactFormState}
          onContactFieldChange={onContactFieldChange}
          onSubmitContact={onSubmitContact}
          loader={loader}
          disableBtn={getDisableBtn()}
          onEdit={handleEditClick}
          submitBtnName={isSingleUpgradeOrShiftingJourney() ? 'Save Changes' : 'Next'}
          showEditBtn={showEditBtn}
        />
      )}
      {(isSingleUpgradeOrShiftingJourney() || renderCircuitAccordion) && (
        <CircuitDetails
          lsiData={lsiData}
          fetchLsiDetails={fetchLsiDetails}
          lsiError={lsiError}
          isEditing={isEditing}
          setLoader={setLoader}
          loader={loader}
          lsiLoading={lsiLoading}
          orderFormState={orderFormState}
          contactFormState={contactFormState}
        />
      )}
    </div>
  );
};

export default OrderDetailsAccordion;
